import React, { useState } from 'react';
import { Device, User } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import ConfirmationDialog from "../tags/ConfirmationDialog";
import { useNavigate } from "react-router-dom";
import { activateDevice, deactivateDevice } from "../devices/devices-api";

interface Props {
    device: Device;
    onDelete: (id: string) => void;
    onActivate: (id: string) => void;
    onDeactivate: (id: string) => void;
}

function UserDeviceRow(props: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 4}}>{props.device.id}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.device.operatingSystem}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.device.active ? 'Active' : 'Inactive'}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div
                            className="menu-item"
                            onClick={() => props.device.active ? props.onDeactivate(props.device.id) : props.onActivate(props.device.id)}
                        >
                            {props.device.active ? 'Deactivate' : 'Activate'}
                        </div>
                    </MenuItem>
                    <MenuItem>
                        <div className="menu-item" onClick={() => setDialogOpen(true)}>
                            Remove
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
            <ConfirmationDialog
                title="Remove device"
                description="Are you sure you want to remove device from this user?"
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={() => {
                    props.onDelete(props.device.id);
                    setDialogOpen(false);
                }}
            />
        </div>
    );
}

export default UserDeviceRow;
